export enum RaiseFundApplicationProcessModule {
  FundRaiseApplication = 1,
  DueDiligence = 2,
  OfferCreation = 3,
  CreateCampaign = 4,
}
